// extracted by mini-css-extract-plugin
module.exports = {"card":"LinkExpired_card__MwZ0a","description":"LinkExpired_description__ozvl9"};